var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBookmark = function SvgBookmark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09 21.06C5.82479 21.06 5.57043 20.9546 5.3829 20.7671C5.19536 20.5796 5.09 20.3252 5.09 20.06L4.94 5.4C4.92796 5.10234 4.97489 4.80525 5.07808 4.52579C5.18127 4.24634 5.33869 3.99004 5.54129 3.77164C5.74389 3.55324 5.98767 3.37705 6.2586 3.25321C6.52954 3.12936 6.82228 3.0603 7.12 3.05L16.71 3C17.0081 3.00521 17.3023 3.06909 17.5757 3.18801C17.8491 3.30692 18.0964 3.47854 18.3035 3.69305C18.5106 3.90756 18.6734 4.16077 18.7826 4.43821C18.8918 4.71565 18.9453 5.01189 18.94 5.31L19.08 19.97C19.0817 20.1452 19.0374 20.3178 18.9514 20.4705C18.8654 20.6232 18.7407 20.7506 18.59 20.84C18.438 20.9278 18.2655 20.974 18.09 20.974C17.9145 20.974 17.742 20.9278 17.59 20.84L11.89 17.68L6.6 20.91C6.44336 20.9975 6.26908 21.0488 6.09 21.06ZM11.85 15.51C12.0238 15.5103 12.195 15.5514 12.35 15.63L17.06 18.24L16.94 5.29C16.94 5.09 16.81 4.95 16.73 4.96L7.13 5.05C7.05 5.05 6.94 5.18 6.94 5.38L7.06 18.28L11.34 15.65C11.4954 15.561 11.6709 15.5128 11.85 15.51Z",
    fill: "#03606A"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bookmark.61b95203.svg";
export { ForwardRef as ReactComponent };